import { createFileRoute } from "@tanstack/react-router";
import { PatientIndex } from "@/features/patients";
import { requirePerm } from "@/lib/auth/guards";

/**
 * `/patients` — the index. The address is already the nav door.
 *
 * The screen is drawn from `GET /v1/patients` (`features/patients/
 * patient-index.tsx`) as the reduced list the delivered payload can fill:
 * name and phone, the server's page, nothing the row does not carry. The
 * delivered row has no record id, so this file does not declare
 * `/patients/$patientId`. `textSearch` is not a search param of this route:
 * what was typed does not belong in the page URL (`DECISIONS.md`
 * 21-09-2026 and 05-10-2026).
 */
export const Route = createFileRoute("/_authenticated/patients")({
  beforeLoad: requirePerm("VIEW_PATIENT"),
  component: PatientIndex,
});
